import { Component, ChangeDetectionStrategy, Input, ChangeDetectorRef } from '@angular/core';
import { CountdownTypes } from '@modules/countdown/enums/countdown-types.enum';

@Component({
  selector: 'mb-announcement',
  templateUrl: './announcement.component.html',
  styleUrls: ['./announcement.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnnouncementComponent {
  public countDownReached = false;

  private _countdownDate: Date | null = null;

  countdownType = CountdownTypes;

  @Input() title?: string;
  @Input() subtitle?: string;
  @Input() showDaysOnly = true;

  @Input()
  set countdownDate(d: Date | null) {
    this._countdownDate = d;
    if (d) {
      if (d.getTime() < Date.now()) {
        this.countDownReached = true;
      } else {
        this.countDownReached = false;
      }
    }
  }
  get countdownDate() {
    return this._countdownDate;
  }
  @Input() countdownLabel: string = '';
  @Input() postCountdownLabel: string = '';
  @Input() isBelowCountdown: boolean = false;

  constructor(private cdr: ChangeDetectorRef) {}

  public finished() {
    this.countDownReached = true;
    this.cdr.detectChanges();
  }
}
